import {NgModule} from '@angular/core';
import {AuthComponent} from './auth.component';
import {LoginComponent} from './login/login.component';
import {ForgetPasswordComponent} from './forget-password/forget-password.component';
import {AuthRoutingModule} from './auth-routing.module';
import {SharedModule} from '../shared/shared.module';
import {ChangePasswordComponent} from './change-password/change-password.component';
import {AuthLoginService} from './auth.service';
import { ChangePasswordDefaultComponent } from './change-password-default/change-password-default.component';


@NgModule({
  imports: [
    AuthRoutingModule,
    SharedModule,
  ],
  declarations: [
    AuthComponent,
    LoginComponent,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    ChangePasswordDefaultComponent
  ],
  providers: [
    AuthLoginService
  ]
})
export class AuthModule { }
